// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__25Qbg","notes":"Notes_notes__3_QZj","note":"Notes_note__Ml4Oh","markdown":"Notes_markdown__75HnN"};